import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "../components/Navbar/Navbar";
import Footer from "../components/Footer/Footer";

const PublicLayout = () => {
  return (
    <div className="h-full w-full">
      <div className="fixed top-0 left-0 right-0 z-50">

      <Navbar />
      </div>
      <div className="min-h-screen mt-20 md:mt-32">
        <Outlet />  
      </div>
      <Footer />
    </div>
  );
};

export default PublicLayout;
